import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var msMaxWidth = 'max-width: 25rem';
  var mq = "@media screen and (".concat(msMaxWidth, ")");
  return {
    card: _defineProperty({
      height: componentTheme.cardHeight,
      width: componentTheme.cardWidth,
      padding: componentTheme.cardPadding,
      margin: componentTheme.cardMargin,
      display: 'inline-flex',
      flexDirection: 'column'
    }, mq, {
      width: 'initial',
      maxWidth: componentTheme.cardWidth
    }),
    details: {
      paddingTop: componentTheme.detailPadding
    }
  };
};
export default generateStyle;